import React from "react";
import {Button, ProgressBar} from 'react-bootstrap';
import coin from  "../../assets/images/withdraw/coin.svg";
import item1 from  "../../assets/images/withdraw/item3.png";
import user from  "../../assets/images/withdraw/user.png";
import warning from  "../../assets/images/withdraw/warning.svg";
import arrow from  "../../assets/images/withdraw/arrow.svg";
const TradeOffer = () => {
  return (
  <div className="trade-offer">

      <div className="trade-user-info">

          <div className="trade-user-pic">
              <img src={user} alt="" />
              <h4>Austistic Panda</h4>
          </div>

          <div className="trade-info-box">
              <div className="trade-info">
                  <p>Account Creation</p>
                  <h5>31st August, 2021</h5>
              </div>
              <div className="trade-info">
                  <p>Steam Level</p>
                  <h5>82</h5>
              </div>
          </div>

      </div>



        <div className="selected-item-grid">

          <div className="selected-item-box">
            <div className="selected-item-cover">
                <img src={item1} alt="" />
            </div>
            <div className="selected-item-info">
              <div className="items-info">
                <span>Contraband Rifle</span>
                <h4>StatTrak™ M4A4 | Howl</h4>
              </div>
              <div className="items-category">Factory New</div>
              <div className="items-price">
                <h5><img src={coin} alt="" /> 1,258.00 <span>-65%</span></h5>
              </div>
            </div>
          </div>

          <div className="selected-item-box">
            <div className="selected-item-cover">
                <img src={item1} alt="" />
            </div>
            <div className="selected-item-info">
              <div className="items-info">
                <span>Contraband Rifle</span>
                <h4>StatTrak™ M4A4 | Howl</h4>
              </div>
              <div className="items-category">Factory New</div>
              <div className="items-price">
                <h5><img src={coin} alt="" /> 1,258.00 <span>-65%</span></h5>
              </div>
            </div>
          </div>

          <div className="selected-item-box">
            <div className="selected-item-cover">
                <img src={item1} alt="" />
            </div>
            <div className="selected-item-info">
              <div className="items-info">
                <span>Contraband Rifle</span>
                <h4>StatTrak™ M4A4 | Howl</h4>
              </div>
              <div className="items-category">Factory New</div>
              <div className="items-price">
                <h5><img src={coin} alt="" /> 1,258.00 <span>-65%</span></h5>
              </div>
            </div>
          </div>

        </div>


        <div className="trade-time-left">
            <p>You have <span>01:30</span> to send the trade offer.</p>
            <ProgressBar now={60} />
        </div>

        <div className="trade-offer-btn">
            <Button>SEND TRADE OFFER <img src={arrow} alt="" /></Button>
        </div>

        <div className="trade-warning">
            <h4><img src={warning} alt="" /> Warning</h4>
            <p>If you don’t accept the buy order within 5 mintes, your sell order will be expired and will be cancelled.</p>
        </div>


  </div>
  );
};

export default TradeOffer;
